module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Einstellungen.6e2cdbe1.svg";